/* Flash deal countdown. Accepts unix seconds (store-time end of day) or an ISO date. */
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function parseEnd(value) {
    if (!value) return NaN;
    if (/^\d{10}$/.test(value)) return parseInt(value, 10) * 1000;
    if (/^\d{13}$/.test(value)) return parseInt(value, 10);
    var ms = Date.parse(value);
    if (!isNaN(ms)) return ms;
    ms = Date.parse(value.replace(' ', 'T'));
    if (!isNaN(ms)) return ms;
    return Date.parse(value.replace(' ', 'T') + 'Z');
  }

  function expire(root) {
    root.classList.add('is-expired');
    root.setAttribute('hidden', 'hidden');
    root.style.display = 'none';
    var section = root.closest('.shopify-section');
    if (section && root.classList.contains('isf-fdbar')) {
      section.style.display = 'none';
    }
  }

  function tick(root) {
    var ends = parseEnd(root.getAttribute('data-isf-flash-ends'));
    if (isNaN(ends)) { expire(root); return; }
    var remaining = ends - Date.now();
    if (remaining <= 0) { expire(root); return; }
    var h = Math.floor(remaining / 3600000);
    var m = Math.floor((remaining % 3600000) / 60000);
    var s = Math.floor((remaining % 60000) / 1000);
    var hh = root.querySelector('[data-isf-flash-hh]');
    var mm = root.querySelector('[data-isf-flash-mm]');
    var ss = root.querySelector('[data-isf-flash-ss]');
    var dd = root.querySelector('[data-isf-flash-dd]');
    if (dd) {
      var d = Math.floor(remaining / 86400000);
      dd.textContent = pad(d);
    }
    if (hh) hh.textContent = pad(h);
    if (mm) mm.textContent = pad(m);
    if (ss) ss.textContent = pad(s);
  }

  function init() {
    document.querySelectorAll('[data-isf-flash-ends]').forEach(function (block) {
      tick(block);
      if (!block.classList.contains('is-expired')) {
        setInterval(function () { tick(block); }, 1000);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
